

















































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import creditCardType from "credit-card-type";
import HasValidation from "@/mixins/HasValidation";

@Component
export default class CreditCardForm extends Mixins(HasValidation) {
  // Props
  @Prop({ required: true })
  public value!: any;
  @Prop({ default: false })
  public isDisabled!: boolean;
  @Prop({ default: false })
  public cardHolderRequired!: boolean;

  public form = this.value;

  public get cardType() {
    const types = creditCardType(this.form.card_num);
    return types.length === 1 ? types[0] : null;
  }

  public get cardNumLength() {
    return this.cardType
      ? this.$_.last(this.$_.sortBy(this.cardType.lengths))
      : 16;
  }

  public get cardMask() {
    let pattern = this.$_.repeat("#", this.cardNumLength);
    const gaps = this.$_.get(this.cardType, "gaps", [4, 8, 12]);
    gaps.forEach((gap, index) => {
      const position = gap + index;
      pattern = [pattern.slice(0, position), " ", pattern.slice(position)].join(
        ""
      );
    });
    return pattern;
  }

  public get cardCvvLength() {
    return this.$_.get(this.cardType, "code.size", 3);
  }

  public get cardCvvMask() {
    return this.$_.repeat("#", this.cardCvvLength);
  }

  public get cardClass() {
    const type = this.$_.get(this.cardType, "type");
    switch (type) {
      case "visa":
      case "mastercard":
      case "diners-club":
      case "discover":
      case "jcb":
      case "unionpay":
      case "maestro":
      case "elo":
      case "hipercard":
      case "american-express":
        return type;
      default:
        return "default";
    }
  }

  public onCardNumberChange(e) {
    this.form.card_num = e.target.value;
    const position = e.target.selectionStart;
    this.$nextTick(() => {
      e.target.setSelectionRange(position, position);
    });
  }

  @Watch("form.card_num")
  public cardNumChanged(cardNum) {
    this.$set(
      this.form,
      "name",
      this.$t("_.card_type_ending", {
        type: this.$_.get(this.cardType, "niceType"),
        last4: cardNum.replace(/\s/g, "").slice(-4)
      })
    );

    if (this.hasError("card_type")) {
      this.removeError("card_type");
    }
  }

  @Watch("cardType")
  public cardTypeChanged(cardType) {
    this.$set(this.form, "card_type", this.$_.get(cardType, "type", null));
  }

  @Watch("form", { deep: true })
  public onFormChange() {
    this.$emit("input", this.form);
  }
}
